import * as icons from 'core/icons';

const viticultores = {
    id: 'viticultor',
    title: 'Viticultor',
    type: 'group',
    collapse: false,
    visible: true,
    children: [
        {
            id: 'informacion',
            title: 'Informacion',
            type: 'item',
            visible: true,
            url: '/b2b/viticultores/informacion',
            icon: icons.BodegaIcon,
            breadcrumbs: false
        },
        {
            id: 'dashboard',
            title: 'Dashboard',
            type: 'item',
            visible: true,
            url: '/b2b/viticultores/dashboard',
            icon: icons.DashboardIcon,
            breadcrumbs: false
        },
        {
            id: 'solicitudes',
            title: 'Solicitudes',
            type: 'item',
            visible: true,
            url: '/b2b/viticultores/solicitudes',
            icon: icons.SolicitudesIcon,
            breadcrumbs: false
        },
        {
            id: 'declaraciones',
            title: 'Declaraciones',
            type: 'item',
            visible: true,
            url: '/b2b/viticultores/declaraciones',
            icon: icons.DeclaracionesIcon,
            breadcrumbs: false
        },
        {
            id: 'validacion',
            title: 'Validacion Cosecha',
            type: 'item',
            visible: true,
            url: '/b2b/viticultores/validacion',
            icon: icons.InspeccionesIcon,
            breadcrumbs: false
        },
        {
            id: 'contable',
            title: 'Contabilidad',
            type: 'item',
            visible: true,
            url: '/b2b/viticultores/contabilidad',
            icon: icons.ContabilidadIcon,
            breadcrumbs: false
        }
    ]
};

export default viticultores;
